export default class ExtenstionCategoryModel {
  public extensionCategoryId: string = ''
  public extensionId: string = ''
  public name: string = ''
  public stage: string = ''
  public order: number = 0

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
